import { useDispatch } from "react-redux";
import { useCallback } from "react";
import { DIALOGS } from "components/Dialogs/constants";
import { setCurrentDialog } from "ducks/dialogs/dialogs";

export const useDialog = <Resources extends string[]>(
  name: DIALOGS,
): ((resources?: Resources, options?: Record<string, unknown>) => void) => {
  const dispatch = useDispatch();

  return useCallback(
    (resources?: Resources, options?: Record<string, unknown>) => {
      dispatch(setCurrentDialog(name, { resources, options }));
    },
    [name, dispatch],
  );
};
